// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

import $ from 'jquery'

/**
 *引入第三方ui框架以及支持的js
 * ui框架依赖bootstrap jQuery
 */
import './assets/css/font/font-awesome.less' // 字体样式库
import './assets/css/reset.css' // reset css 重置默认样式
import './assets/css/bootstrap.min.css'
import './assets/less/components.less'
import './assets/less/core.less'
import './assets/less/elements.less'
import './assets/less/icons.less'
// import './assets/less/menu.less'
import './assets/less/pages.less'
import './assets/less/responsive.less'
import './assets/less/variables.less'
import './assets/js/bootstrap.min'
import './assets/js/detect'
import './assets/js/fastclick'
import './assets/js/jquery.blockUI'
import './assets/js/waves'
import './assets/js/jquery.slimscroll'
import './assets/js/jquery.scrollTo.min'
import './assets/plugins/switchery/switchery.min'

// import './assets/js/jquery.core'

// -----------element ui ----------//
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/**
 * 配合msgbox弹窗引入自定义内容样式
 * 存在背景图片，需要在此处引用避免报错
 * */
import './assets/less/custom-msgbox.styl'
// -----------element ui end ----------//

import axios from './factory-api/https'
import uploadAxios from './factory-api/upload-https'
import httpsV3 from './factory-api/https-v3'
import httpsApi from './factory-api/api'

// 头部面包屑/菜单组件
import middleTab from '@/components/middle-tab/middle-tab'

// 引用对象存储SDK
import uploadFile from './factory-api/uploadFile'
import uploadFileBatch from './factory-api/uploadFileBatch'

import echarts from 'echarts'

// 引入折线图。
import line from 'echarts/lib/chart/line'

// js-base64
import jsBase64 from 'js-base64'

// 拖拽排序
import VueDND from 'awe-dnd'

import appConfig from './appConfig'

// 导入全局工具函数
import './util/index'

Vue.use(ElementUI)

Vue.prototype.$loading = ElementUI.Loading.service
Vue.prototype.$msgbox = ElementUI.MessageBox
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$notify = ElementUI.Notification

Vue.prototype.$http = axios
Vue.prototype.$uploadHttp = uploadAxios
Vue.prototype.$httpV3 = httpsV3
Vue.prototype.$httpsApi = httpsApi

Vue.component('middleTab', middleTab)
// 单文件上传
Vue.prototype.$uploadFile = uploadFile
// 批量文件上传
Vue.prototype.$uploadFileBatch = uploadFileBatch

Vue.use(line)

Vue.prototype.$echarts = echarts

Vue.prototype.$Base64 = jsBase64.Base64

Vue.use(VueDND)
// 是否关闭debug调试
if (!appConfig.isDebug) {
  console.log = function (val) {
    return false
  }
}

Vue.config.productionTip = false
Vue.filter('dateFormat', originVal => {
  const dt = new Date(Number(originVal))
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js